module.exports = __webpack_public_path__ + "static/media/60.025b1ffc.svg";